// extracted by mini-css-extract-plugin
export default {"ul":"CompD_ul__ShGBp","label":"CompD_label__LDsHL","last":"CompD_last__ecf9v","item":"CompD_item__wXDh2","total":"CompD_total__17mCQ"};